import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';

import { ClientFinancialProfileModel } from '../../model';

@Injectable({
  providedIn: 'root',
})
export class ClientFinancialProfileService {
  constructor(private http: HttpClient) {}

  public getFinancialProfileByClientId(clientId: string): Observable<ClientFinancialProfileModel> {
    return this.http.get<ClientFinancialProfileModel>(
      `${environment.apiEndpoint}/account/financial-profile/${clientId}`,
    );
  }

  public updateFinancialProfileByClientId(clientId: string, body: ClientFinancialProfileModel): Observable<void> {
    return this.http.put<void>(`${environment.apiEndpoint}/account/financial-profile/${clientId}`, body);
  }
}
